import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './collider-lab.css'

const ColliderLab = (props) => {
  return (
    <div className="collider-lab-container1">
      <Helmet>
        <title>Collider-Lab - MDMC.dev</title>
        <meta property="og:title" content="Collider-Lab - MDMC.dev" />
        <link
          rel="canonical"
          href="https://mdmc.dev/collider-lab"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="collider-lab-container2">
        <div className="collider-lab-container3">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="hero-reactor">
        <div className="hero-reactor__background">
          <video
            src="https://videos.pexels.com/video-files/34470016/14605872_640_360_24fps.mp4"
            loop="true"
            muted="true"
            autoPlay="true"
            playsInline="true"
            className="hero-reactor__video"
          ></video>
          <div className="hero-reactor__overlay"></div>
        </div>
        <div className="hero-reactor__container">
          <div className="hero-reactor__core-wrapper">
            <div className="hero-reactor__core">
              <img
                alt="Meme Reactor Core"
                src="https://images.pexels.com/photos/9962890/pexels-photo-9962890.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="hero-reactor__core-image"
              />
              <div className="hero-reactor__core-glow"></div>
            </div>
          </div>
          <div className="hero-reactor__content">
            <h1 className="collider-lab-hero-title hero-title">
              Collider Lab: The MDMC.dev Protocol
            </h1>
            <p className="hero-subtitle">
              Step inside the massive dank meme collider. We simulate the chaos
              so you don&apos;t have to. Real-time memetic synthesis in
              progress.
            </p>
            <div className="hero-reactor__actions">
              <a className="collider-lab-btn-lg btn btn-primary btn-lg" href="/meme-generator">
                Run Simulation
              </a>
              <a className="collider-lab-btn-lg btn btn-lg btn-outline" href="/output-zone">
                Access Dev Logs
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="sim-showcase">
        <div className="sim-showcase__container">
          <h2 className="section-title">Live Collision Streams</h2>
          <div className="sim-showcase__masonry">
            <div className="sim-card--tall sim-card">
              <img
                alt="Simulation Alpha"
                src="https://images.pexels.com/photos/14032498/pexels-photo-14032498.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="sim-card__img"
              />
              <div className="sim-card__info">
                <span className="sim-card__tag">Active</span>
                <h3 className="section-subtitle">Alpha-7 Synthesis</h3>
                <div className="sim-card__stats">
                  <span>Chaos: 98%</span>
                  <span>Yield: 4.2M Dank</span>
                </div>
              </div>
            </div>
            <div className="sim-card">
              <img
                alt="Simulation Beta"
                src="https://images.pexels.com/photos/12489187/pexels-photo-12489187.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="sim-card__img"
              />
              <div className="sim-card__info">
                <span className="sim-card__tag">Archived</span>
                <h3 className="section-subtitle">Beta Drift</h3>
                <div className="sim-card__stats">
                  <span>Chaos: 12%</span>
                  <span>Yield: 10k Dank</span>
                </div>
              </div>
            </div>
            <div className="sim-card">
              <img
                alt="Simulation Gamma"
                src="https://images.pexels.com/photos/18545039/pexels-photo-18545039.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="sim-card__img"
              />
              <div className="sim-card__info">
                <span className="sim-card__tag">Active</span>
                <h3 className="section-subtitle">Gamma Burst</h3>
                <div className="sim-card__stats">
                  <span>Chaos: 85%</span>
                  <span>Yield: 1.1M Dank</span>
                </div>
              </div>
            </div>
            <div className="sim-card--tall sim-card">
              <img
                alt="Simulation Delta"
                src="https://images.pexels.com/photos/8344064/pexels-photo-8344064.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="sim-card__img"
              />
              <div className="sim-card__info">
                <span className="sim-card__tag">Unstable</span>
                <h3 className="section-subtitle">Delta Void</h3>
                <div className="sim-card__stats">
                  <span>Chaos: 100%</span>
                  <span>Yield: ??? Dank</span>
                </div>
              </div>
            </div>
            <div className="sim-card">
              <img
                alt="Simulation Epsilon"
                src="https://images.pexels.com/photos/18545016/pexels-photo-18545016.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="sim-card__img"
              />
              <div className="sim-card__info">
                <span className="sim-card__tag">Testing</span>
                <h3 className="section-subtitle">Epsilon Flow</h3>
                <div className="sim-card__stats">
                  <span>Chaos: 45%</span>
                  <span>Yield: 500k Dank</span>
                </div>
              </div>
            </div>
            <div className="sim-card">
              <img
                alt="Simulation Zeta"
                src="https://images.pexels.com/photos/2760615/pexels-photo-2760615.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="sim-card__img"
              />
              <div className="sim-card__info">
                <span className="sim-card__tag">Active</span>
                <h3 className="section-subtitle">Zeta Prime</h3>
                <div className="sim-card__stats">
                  <span>Chaos: 77%</span>
                  <span>Yield: 2.8M Dank</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="metric-rail">
        <div className="metric-rail__header">
          <h2 className="section-title">Collider Health Metrics</h2>
          <p className="section-content">
            Real-time telemetry from the meme core.
          </p>
        </div>
        <div className="metric-rail__track">
          <div className="metric-card">
            <div className="metric-card__icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="m12 14l4-4M3.34 19a10 10 0 1 1 17.32 0"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h3 className="section-subtitle">Dankness Index</h3>
            <div className="metric-card__value">
              <span>9,001.4</span>
            </div>
            <p className="section-content">
              Current saturation of memetic relevance across all layers.
            </p>
          </div>
          <div className="metric-card">
            <div className="metric-card__icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="1" cx="12" cy="12"></circle>
                  <path d="M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9c-4.54-4.52-9.87-6.54-11.9-4.5c-2.04 2.03-.02 7.36 4.5 11.9c4.54 4.52 9.87 6.54 11.9 4.5"></path>
                  <path d="M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9c-2.03-2.04-7.36-.02-11.9 4.5c-4.52 4.54-6.54 9.87-4.5 11.9c2.03 2.04 7.36.02 11.9-4.5"></path>
                </g>
              </svg>
            </div>
            <h3 className="section-subtitle">RNG Drift</h3>
            <div className="metric-card__value">
              <span>±0.042%</span>
            </div>
            <p className="section-content">
              Deviation from standard randomness protocols.
            </p>
          </div>
          <div className="metric-card">
            <div className="metric-card__icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M10 2v6.292a7 7 0 1 0 4 0V2M5 15h14M8.5 2h7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h3 className="section-subtitle">Meme Half-Life</h3>
            <div className="metric-card__value">
              <span>4.2 Hours</span>
            </div>
            <p className="section-content">
              Estimated time until a meme loses 50% of its dankness.
            </p>
          </div>
          <div className="metric-card">
            <div className="metric-card__icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="m5 7l5 5l-5 5m7 2h7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h3 className="section-subtitle">Logic Leak</h3>
            <div className="metric-card__value">
              <span>CRITICAL</span>
            </div>
            <p className="section-content">
              Non-memetic data attempting to influence the core.
            </p>
          </div>
        </div>
      </section>
      <section className="tool-rail">
        <div className="tool-rail__header">
          <h2 className="section-title">Experimental Tools</h2>
          <p className="section-content">
            Unstable prototypes for the brave. Use at your own risk.
          </p>
        </div>
        <div className="tool-rail__track">
          <div className="tool-card">
            <div className="tool-card__badge">
              <span>BETA</span>
            </div>
            <h3 className="section-subtitle">A/B Forker</h3>
            <p className="section-content">
              Split a single meme into two parallel timelines to compare
              engagement yields.
            </p>
            <button className="btn btn-sm btn-accent">Opt In</button>
          </div>
          <div className="tool-card">
            <div className="tool-card__badge tool-card__badge--alpha">
              <span>ALPHA</span>
            </div>
            <h3 className="section-subtitle">Proto-Gen V3</h3>
            <p className="section-content">
              Neural-network based generator that creates memes from pure white
              noise.
            </p>
            <button className="btn btn-sm btn-accent">Join Waitlist</button>
          </div>
          <div className="tool-card">
            <div className="tool-card__badge">
              <span>STABLE</span>
            </div>
            <h3 className="section-subtitle">Chaos Injector</h3>
            <p className="section-content">
              Manually override the RNG to force high-energy collisions in the
              lab.
            </p>
            <button className="btn btn-sm btn-accent">Launch Tool</button>
          </div>
          <div className="tool-card">
            <div className="tool-card__badge tool-card__badge--alpha">
              <span>ALPHA</span>
            </div>
            <h3 className="section-subtitle">Deep Dank Blur</h3>
            <p className="section-content">
              An experimental filter that hides the punchline until the user is
              ready.
            </p>
            <button className="btn btn-sm btn-accent">Try Preview</button>
          </div>
        </div>
      </section>
      <section className="dev-timeline">
        <div className="dev-timeline__container">
          <h2 className="section-title">Developer Journal</h2>
          <div className="timeline">
            <div className="timeline__line"></div>
            <div className="timeline__item--left timeline__item">
              <div className="timeline__marker"></div>
              <div className="timeline__content">
                <span className="timeline__date">2026.04.12</span>
                <h3 className="section-subtitle">The Great RNG Drift</h3>
                <p className="section-content">
                  Core stability reached 0.01%. We had to purge the cache. 14
                  million memes were lost, but the collider survived.
                </p>
                <div className="timeline__log">
                  <span>LOG: PURGE_COMPLETE_STATUS_OK</span>
                </div>
              </div>
            </div>
            <div className="timeline__item timeline__item--right">
              <div className="timeline__marker"></div>
              <div className="timeline__content">
                <span className="timeline__date">2026.03.28</span>
                <h3 className="section-subtitle">Neural Synthesis Patch</h3>
                <p className="section-content">
                  Implemented the Proto-Gen V3 backend. It started generating
                  images of cats with laser eyes. Working as intended.
                </p>
                <div className="timeline__log">
                  <span>LOG: CAT_LASER_ENABLED</span>
                </div>
              </div>
            </div>
            <div className="timeline__item--left timeline__item">
              <div className="timeline__marker"></div>
              <div className="timeline__content">
                <span className="timeline__date">2026.03.15</span>
                <h3 className="section-subtitle">Hardware Upgrade</h3>
                <p className="section-content">
                  Replaced the water-cooling with liquid dankness. Temperatures
                  dropped by 40 degrees. Frame rates doubled.
                </p>
                <div className="timeline__log">
                  <span>LOG: COOLANT_UPGRADE_SUCCESS</span>
                </div>
              </div>
            </div>
            <div className="timeline__item timeline__item--right">
              <div className="timeline__marker"></div>
              <div className="timeline__content">
                <span className="timeline__date">2026.02.01</span>
                <h3 className="section-subtitle">Project Genesis</h3>
                <p className="section-content">
                  The first collision was successful. MDMC.dev is officially
                  online. The world will never be the same.
                </p>
                <div className="timeline__log">
                  <span>LOG: SYSTEM_ONLINE</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="collision-gallery">
        <div className="collision-gallery__container">
          <h2 className="section-title">Iconic Collisions</h2>
          <div className="collision-gallery__grid">
            <div className="collision-item">
              <img
                alt="Collision Result 1"
                src="https://images.pexels.com/photos/7650783/pexels-photo-7650783.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="collision-item__img"
              />
              <div className="collision-item__overlay">
                <div className="collision-item__info">
                  <h3 className="section-subtitle">Cyber-Siren V1</h3>
                  <p className="section-content">
                    Result of mixing Neon-Punk with Retro-Synth.
                  </p>
                  <div className="collision-item__actions">
                    <button className="btn btn-sm btn-secondary">Zoom</button>
                    <button className="btn btn-sm btn-outline">Share</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="collision-item--wide collision-item">
              <img
                alt="Collision Result 2"
                src="https://images.pexels.com/photos/7689080/pexels-photo-7689080.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="collision-item__img"
              />
              <div className="collision-item__overlay">
                <div className="collision-item__info">
                  <h3 className="section-subtitle">Screen Overload</h3>
                  <p className="section-content">
                    A 4-way collision involving CRT aesthetics and high-energy
                    memes.
                  </p>
                  <div className="collision-item__actions">
                    <button className="btn btn-sm btn-secondary">Zoom</button>
                    <button className="btn btn-sm btn-outline">Share</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="collision-item">
              <img
                alt="Collision Result 3"
                src="https://images.pexels.com/photos/8721322/pexels-photo-8721322.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="collision-item__img"
              />
              <div className="collision-item__overlay">
                <div className="collision-item__info">
                  <h3 className="section-subtitle">VR Void</h3>
                  <p className="section-content">
                    The first successful immersion collision recorded in the
                    lab.
                  </p>
                  <div className="collision-item__actions">
                    <button className="btn btn-sm btn-secondary">Zoom</button>
                    <button className="btn btn-sm btn-outline">Share</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="collision-item">
              <img
                alt="Collision Result 4"
                src="https://images.pexels.com/photos/8108092/pexels-photo-8108092.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="collision-item__img"
              />
              <div className="collision-item__overlay">
                <div className="collision-item__info">
                  <h3 className="section-subtitle">Tactical Dank</h3>
                  <p className="section-content">
                    Explosive memetic yield detected during this run.
                  </p>
                  <div className="collision-item__actions">
                    <button className="btn btn-sm btn-secondary">Zoom</button>
                    <button className="btn btn-sm btn-outline">Share</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="video-demos">
        <div className="video-demos__container">
          <h2 className="section-title">Lab Briefings</h2>
          <div id="videoCarousel" className="video-carousel">
            <div className="video-carousel__track">
              <div className="collider-lab-video-card">
                <div className="video-card__media">
                  <video
                    src="https://videos.pexels.com/video-files/28643100/12440627_640_360_30fps.mp4"
                    loop="true"
                    muted="true"
                    className="video-card__video"
                  ></video>
                  <div className="video-card__play">
                    <svg
                      width="48"
                      xmlns="http://www.w3.org/2000/svg"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8 5.14v13.72l11-6.86L8 5.14z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="video-card__content">
                  <h3 className="section-subtitle">Protocol X-1: The Spark</h3>
                  <p className="section-content">
                    A deep dive into the initial ignition of the collider core.
                    [03:45]
                  </p>
                </div>
              </div>
              <div className="collider-lab-video-card">
                <div className="video-card__media">
                  <video
                    src="https://videos.pexels.com/video-files/29689646/12768588_640_360_30fps.mp4"
                    loop="true"
                    muted="true"
                    className="video-card__video"
                  ></video>
                  <div className="video-card__play">
                    <svg
                      width="48"
                      xmlns="http://www.w3.org/2000/svg"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8 5.14v13.72l11-6.86L8 5.14z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="video-card__content">
                  <h3 className="section-subtitle">Synthesis Theory</h3>
                  <p className="section-content">
                    How we merge disparate meme formats into unified chaos.
                    [05:12]
                  </p>
                </div>
              </div>
              <div className="collider-lab-video-card">
                <div className="video-card__media">
                  <video
                    src="https://videos.pexels.com/video-files/34914411/14789788_640_360_30fps.mp4"
                    loop="true"
                    muted="true"
                    className="video-card__video"
                  ></video>
                  <div className="video-card__play">
                    <svg
                      width="48"
                      xmlns="http://www.w3.org/2000/svg"
                      height="48"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M8 5.14v13.72l11-6.86L8 5.14z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="video-card__content">
                  <h3 className="section-subtitle">Safety First (Mostly)</h3>
                  <p className="section-content">
                    What to do when the logic leak reaches critical levels.
                    [02:20]
                  </p>
                </div>
              </div>
            </div>
            <div className="video-carousel__controls">
              <button id="prevVideo" className="btn btn-sm btn-outline">
                Prev
              </button>
              <button id="nextVideo" className="btn btn-sm btn-outline">
                Next
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="collider-lab-cta-section">
        <div className="cta-section__trigger">
          <button id="openCtaModal" className="btn btn-primary btn-xl">
            Enlist in the Crew
          </button>
        </div>
        <dialog id="ctaModal" className="cta-modal">
          <div className="cta-modal__content">
            <h2 className="section-title">Join the MDMC.dev Protocol</h2>
            <p className="section-content">
              Become a lab technician. Report bugs, feed the reactor, and help
              us push the boundaries of memetic science.
            </p>
            <form
              action="/enlist"
              method="POST"
              data-form-id="ee2f49e5-a538-4b5a-ad9f-591a9ffd5b07"
              className="collider-lab-cta-form"
            >
              <div className="form-group">
                <input
                  type="text"
                  id="thq_textinput_fDnr"
                  name="textinput"
                  required="true"
                  placeholder="Callsign (Username)"
                  data-form-field-id="thq_textinput_fDnr"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  id="thq_textinput_MgcW"
                  name="textinput"
                  required="true"
                  placeholder="Neural Link (Email)"
                  data-form-field-id="thq_textinput_MgcW"
                  className="form-input"
                />
              </div>
              <div className="collider-lab-form-actions">
                <button
                  id="thq_button_JAQf"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_JAQf"
                  className="btn btn-primary"
                >
                  Authorize Access
                </button>
                <button
                  id="closeCtaModal"
                  name="button"
                  type="button"
                  data-form-field-id="closeCtaModal"
                  className="btn btn-link"
                >
                  Abort Mission
                </button>
              </div>
            </form>
          </div>
        </dialog>
      </div>
      <div className="collider-lab-container4">
        <div className="collider-lab-container5">
          <Script
            html={`<style>
        @keyframes corePulse {0%,100% {transform: scale(1);
box-shadow: 0 0 30px var(--color-primary);}
50% {transform: scale(1.05);
box-shadow: 0 0 70px var(--color-primary);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="collider-lab-container6">
        <div className="collider-lab-container7">
          <Script
            html={`<script defer data-name="collider-lab-logic">
(function(){
  // Modal Logic
  const ctaModal = document.getElementById("ctaModal")
  const openCtaBtn = document.getElementById("openCtaModal")
  const closeCtaBtn = document.getElementById("closeCtaModal")

  if (openCtaBtn && ctaModal) {
    openCtaBtn.addEventListener("click", () => {
      ctaModal.showModal()
    })
  }

  if (closeCtaBtn && ctaModal) {
    closeCtaBtn.addEventListener("click", () => {
      ctaModal.close()
    })
  }

  // Backdrop click to close modal
  ctaModal?.addEventListener("click", (e) => {
    if (e.target === ctaModal) {
      ctaModal.close()
    }
  })

  // Simple Carousel Logic for Video Demos
  const carouselTrack = document.querySelector(".video-carousel__track")
  const prevBtn = document.getElementById("prevVideo")
  const nextBtn = document.getElementById("nextVideo")

  if (carouselTrack && prevBtn && nextBtn) {
    let currentIndex = 0
    const cards = document.querySelectorAll(".video-card")

    nextBtn.addEventListener("click", () => {
      if (currentIndex < cards.length - 1) {
        currentIndex++
        updateCarousel()
      } else {
        currentIndex = 0
        updateCarousel()
      }
    })

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--
        updateCarousel()
      } else {
        currentIndex = cards.length - 1
        updateCarousel()
      }
    })

    function updateCarousel() {
      const offset = currentIndex * -100
      carouselTrack.style.transform = \`translateX(calc(\${offset}% - \${currentIndex * 24}px))\`

      // Stop all videos when switching
      document.querySelectorAll(".video-card__video").forEach((v) => v.pause())
    }
  }

  // Video Play Interaction
  document.querySelectorAll(".video-card__play").forEach((playBtn) => {
    playBtn.addEventListener("click", function () {
      const video = this.previousElementSibling
      if (video.paused) {
        video.play()
        this.style.opacity = "0"
      } else {
        video.pause()
        this.style.opacity = "1"
      }
    })
  })

  // Parallax Effect for Hero Core
  window.addEventListener("scroll", () => {
    const core = document.querySelector(".hero-reactor__core")
    if (core) {
      const scrolled = window.pageYOffset
      core.style.transform = \`translateY(\${scrolled * 0.15}px) scale(\${1 + scrolled * 0.0002})\`
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ColliderLab
